import { Grid } from "@mui/material";
import { InputField, SelectField, FormBase, FormState, getDefaultValue, FormSubmitCallback, ApiValidationError, mapApiFieldValidationErrors, SelectOption, FormBaseProps } from "ui/Form";
import { z } from "zod";
import { useState, useEffect } from "react";
import { Field, FieldProps, Form } from "react-final-form";
import { RoleDataType } from "ft-shared-graphql/types";
const STAFF_FORM_FIELDS: FieldProps<string, any>[] = [
    {
        name: "firstName",
        label: "First Name",
        component: InputField,
        required: true,
        fullWidth: true,
        grid: {
            xs: 6,
        },
    },
    {
        name: "middleName",
        label: "Middle Name",
        component: InputField,
        required: false,
        fullWidth: true,
        grid: {
            xs: 6,
        },
    },
    {
        name: "lastName",
        label: "Last Name",
        component: InputField,
        required: true,
        fullWidth: true,
        grid: {
            xs: 6,
        },
    },
    {
        name: "roleType",
        label: "User Role / Type",
        component: SelectField,
        required: true,
        fullWidth: true,
        grid: {
            xs: 6,
        }
    },
    {
        name: "jobTitle",
        label: "Job Title",
        component: InputField,
        required: false,
        fullWidth: true,
        grid: {
            xs: 12,
        },
    },
    {
        name: "email",
        label: "Email",
        component: InputField,
        required: true,
        fullWidth: true,
        grid: {
            xs: 12,
        },
    }
];
const staffEditSchema = z.object({
    firstName: z.string().trim().nonempty().max(255),
    middleName: z.string().trim().max(255).nullish(),
    lastName: z.string().trim().nonempty().max(255),
    jobTitle: z.string().trim().max(255).nullish(),
    email: z.string().nonempty().email(),
    roleType: z.enum(["MEDICAL_STANDARD", "MEDICAL_ADMIN", "MEDICAL_STANDARD", "EDUCATION_STANDARD", "EDUCATION_ADMIN", "EDUCATION_SUPER", "SUPPORT_ADMIN"])
    // roleType: z.union([z.literal("MEDICAL_STANDARD"), z.literal("MEDICAL_ADMIN"), z.literal("MEDICAL_SUPER"), z.literal("EDUCATION_STANDARD"), z.literal("EDUCATION_ADMIN"), z.literal("EDUCATION_SUPER"), z.literal("SUPPORT ADMIN"), z.null(), z.undefined()]),
    // startDate: z.coerce.date()
});

export type StaffFormSchema = z.infer<typeof staffEditSchema>;

const formValidator = <T extends z.ZodType<any, any>>(schema: T) => (values: any) => {
    try {
        schema.parse(values);
    } catch (err) {
        return (err as z.ZodError).formErrors.fieldErrors;
    }
};

const mapSelectOptions = (options: any[]): SelectOption[] => options.map(x => ({
    label: x.clientFacingName,
    value: x.normalizedName.replace(/\s+/g, "_"),
    isDefault: x.default,
    disabled: x.normalizedName == "MEDICAL SUPER" || x.normalizedName == "EDUCATION SUPER"
})) ?? []

export type StaffFormProps = {
    roles: RoleDataType[]
    onSubmit: (values: StaffFormSchema) => Promise<ReturnType<FormSubmitCallback>>
    onCancel: () => void
} & Pick<FormBaseProps<StaffFormSchema>, "initialValues" | "readonly">

const AddStaffForm = ({ roles, onCancel, onSubmit, initialValues, readonly }: StaffFormProps) => {
    const [formState, setFormState] = useState<FormState>({
        fields: STAFF_FORM_FIELDS
    });

    useEffect(() => {
        if (!roles) return;
        var options = mapSelectOptions(roles ?? [])
        setFormState((prev) => ({
            ...prev,
            fields: prev.fields.map((field) => {
                if (field.name !== "roleType") return field;

                return {
                    ...field,
                    options,
                };
            }),
        }));
        // setRoleOptions(options);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [STAFF_FORM_FIELDS, roles]);


    const StaffForm = FormBase<StaffFormSchema>({
        fields: formState.fields,
        initialValues: initialValues ?? {},
        validationSchema: staffEditSchema,
        buttonSubmitLabel: "Save",
        buttonCancelLabel: "Cancel",
        readonly,
        onSubmit: onSubmit,
        onCancel: onCancel
    })
    return StaffForm
};

export default AddStaffForm;
